
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  DuplicateSupplierParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\DuplicateSupplierParameters.ts

export class DuplicateSupplierParameters {

  // int SupplierId
  public SupplierId: number=0;

  // string UniqueId
  public UniqueId?: string=null;

  // string Motif
  public Motif?: string=null;
}